import { html, when } from "@ni/fast-element";
/**
 * The template for the {@link @ni/fast-foundation#(AnchoredRegion:class)} component.
 * @public
 */
export const anchoredRegionTemplate = (context, definition) => html `
    <template class="${x => (x.initialLayoutComplete ? "loaded" : "")}">
        ${when(x => x.initialLayoutComplete, html `
                <slot></slot>
            `)}
    </template>
`;
